import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ReturnOrderFollowUpFieldsFragmentDoc } from '../fragments/opsOrderDetail.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResolveReturnOrderDiscrepancyMutationVariables = Types.Exact<{
  merchantOrderId: Types.Scalars['UUID'];
  note: Types.Scalars['String'];
}>;


export type ResolveReturnOrderDiscrepancyMutation = { __typename?: 'Mutation', resolveReturnOrderDiscrepancy: { __typename?: 'ReturnOrderFollowUp', id: string, discrepancy_status?: Types.ReturnOrderDiscrepancyStatus | null, discrepancy_mail_sent_at?: string | null, resolved_at?: string | null, resolved_by?: string | null, resolution_note?: string | null, parcel_lost_at?: string | null, parcel_lost_by?: string | null, lost_container_count: number, can_set_parcel_lost: boolean, discrepancy_lines: Array<{ __typename?: 'ReturnOrderDiscrepancyLine', kind: Types.ReturnOrderLineKind, type_id: number, name?: string | null, announced: number, received: number, difference: number }> } };


export const ResolveReturnOrderDiscrepancyDocument = gql`
    mutation ResolveReturnOrderDiscrepancy($merchantOrderId: UUID!, $note: String!) {
  resolveReturnOrderDiscrepancy(merchant_order_id: $merchantOrderId, note: $note) {
    ...ReturnOrderFollowUpFields
  }
}
    ${ReturnOrderFollowUpFieldsFragmentDoc}`;
export type ResolveReturnOrderDiscrepancyMutationFn = Apollo.MutationFunction<ResolveReturnOrderDiscrepancyMutation, ResolveReturnOrderDiscrepancyMutationVariables>;

/**
 * __useResolveReturnOrderDiscrepancyMutation__
 *
 * To run a mutation, you first call `useResolveReturnOrderDiscrepancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveReturnOrderDiscrepancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveReturnOrderDiscrepancyMutation, { data, loading, error }] = useResolveReturnOrderDiscrepancyMutation({
 *   variables: {
 *      merchantOrderId: // value for 'merchantOrderId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useResolveReturnOrderDiscrepancyMutation(baseOptions?: Apollo.MutationHookOptions<ResolveReturnOrderDiscrepancyMutation, ResolveReturnOrderDiscrepancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveReturnOrderDiscrepancyMutation, ResolveReturnOrderDiscrepancyMutationVariables>(ResolveReturnOrderDiscrepancyDocument, options);
      }
export type ResolveReturnOrderDiscrepancyMutationHookResult = ReturnType<typeof useResolveReturnOrderDiscrepancyMutation>;
export type ResolveReturnOrderDiscrepancyMutationResult = Apollo.MutationResult<ResolveReturnOrderDiscrepancyMutation>;
export type ResolveReturnOrderDiscrepancyMutationOptions = Apollo.BaseMutationOptions<ResolveReturnOrderDiscrepancyMutation, ResolveReturnOrderDiscrepancyMutationVariables>;